export default __webpack_public_path__ + "media/images/facebook-5167e248338254afad7deba5ac62c458.svg";